import React from 'react';
import { Link } from "react-router-dom";
import * as Backend from "../../backend.js";
import FleetTaskEditor from "./tasks/fleet-task-editor.js";
import * as util from "../../other/util.js";
import ResourcesView from "../resources-view.js";
import FleetStatistics from "./util/fleet-statistics.js";
import ShipCollection from "../../share/ship-collection.js";

// Shows details about one fleet and allows to assign tasks
class FleetView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this.refreshState();
    }

    refreshState() {
        let fleet_id = this.props.params.fleet_id;
        Backend.getFleetDetails(fleet_id, (res) => {
            let fleet = res.fleet;
            if (!fleet) {
                this.setState({ fleet: null });
                return;
            }
            fleet = new ShipCollection(fleet);
            this.setState({
                fleet: fleet,
                tasks: util.clone(fleet.tasks),
            });
        });
    }

    render() {
        let fleet = this.state.fleet;
        if (!fleet) {
            return (<util.LoadingBar thing={fleet} thingName="fleet" />);
        }

        return (
            <div>
                <h1>Fleet: {fleet.name}</h1>
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "50%" }}>
                        {this._renderFleetMetaInfo()}
                        <h4>Cargo</h4>
                        <ResourcesView resources={fleet.resources} />
                        <h4>Actions</h4>
                        <TransferButton fleet={fleet} />
                        <DisbandButton onDisbandFleet={() => this._handleDisbandFleet()} />
                    </div>
                    <div style={{ flex: "50%" }}>
                        <FleetStatistics fleet={fleet} />
                    </div>
                </div>

                <FleetTaskEditor tasks={this.state.tasks}
                    mode={"NORMAL"}
                    fleet={this.state.fleet}
                    onUpdateTaskArray={(tasks) => this._handleUpdateTaskArray(tasks)}
                    onCommitTask={(task) => this._handleCommitTask(task)}
                />

                <util.JsonDebug obj={fleet} />
            </div>
        );
    }

    _renderFleetMetaInfo() {
        let fleet = this.state.fleet;

        return (
            <div>
                <table>
                    <tbody>
                        <tr>
                            <td width="120px">Designation:</td>
                            <td>{fleet.name}</td>
                        </tr>
                        <tr>
                            <td>Location:</td>
                            <td>{this._renderLocation()}</td>
                        </tr>
                        <OverviewStatusRow fleet={fleet} />
                        <OverviewCombatRow fleet={fleet} />
                        <OverviewTimeRow fleet={fleet} />
                        <tr>
                            <td>Log:</td>
                            <td>
                                <util.ChatLink chat_id={fleet.chat_log_id} text={"view"} />
                            </td>
                        </tr>
                        <tr>
                            <td />
                            <td />
                        </tr>

                    </tbody>
                </table>
                <h4>Ships</h4>
                <table className="resources" style={{ width: "90%" }}>
                    <tbody>
                        {fleet.ships.map((ship_type, idx) => {
                            return (
                                <tr key={idx}>
                                    <td>{ship_type.count}x</td>
                                    <td><Link className="link-button" to={"/game/ship-design/" + ship_type.design.id}>{ship_type.design.name}</Link></td>
                                    <td>{(Math.round(fleet.getDamageRatioForShipType(ship_type) * 1000) / 10).toFixed(1)}%</td>
                                </tr>);
                        })}
                    </tbody>
                </table>
            </div>);
    }

    _renderLocation() {
        let fleet = this.state.fleet;
        if (fleet.location) {
            return (<util.PlanetLink planet={fleet.location} showOwner={true} />);
        }
        return (<span>Deep space</span>);
    }

    _handleUpdateTaskArray(tasks) {
        this.setState({ tasks: tasks });
    }

    _handleCommitTask(task) {
        const index = task.index;
        Backend.tryAddTaskToFleet(this.state.fleet.id, this.state.tasks[index], (res) => {
            if (res.success) {
                let local_tasks = util.clone(res.fleet.tasks);
                for (let i = 0; i < this.state.tasks.length; i++) {
                    if (this.state.tasks[i].pending && this.state.tasks[i].index !== index) {
                        local_tasks.push(util.clone(this.state.tasks[i]));
                    }
                }

                FleetTaskEditor.helper_cleanUpTaskIndexes(local_tasks);
                this.setState({
                    fleet: new ShipCollection(res.fleet),
                    tasks: local_tasks,
                });
            } else {
                alert(res.error);
            }
        });
    }

    _handleDisbandFleet() {
        Backend.disbandFleet(this.state.fleet.id, (res) => {
            console.log("Disband fleet response:", res);
            if (res.success) {
                this.props.navigate('/game/fleet-overview');
            } else {
                alert(res.error);
            }
        });
    }
}

class OverviewStatusRow extends React.Component {
    render() {
        let fleet = this.props.fleet;

        return (
            <tr>
                <td>Status:</td>
                <td>
                    <util.FleetStatus fleet={fleet} />
                </td>
            </tr>);
    }
}

class OverviewCombatRow extends React.Component {
    render() {
        let fleet = this.props.fleet;
        if (!fleet.next_combat_tick) {
            return null;
        }

        return (
            <React.Fragment>
                <tr>
                    <td>Combat:</td>
                    <td style={{ color: "red" }}>
                        Fighting {fleet.number_of_fleets} fleets!
                    </td>
                </tr>
                <tr>
                    <td>Next Round:</td>
                    <td>
                        <util.Timer date={fleet.next_combat_tick} />
                    </td>
                </tr>
            </React.Fragment>
        );
    }
}

class OverviewTimeRow extends React.Component {
    render() {
        let fleet = this.props.fleet;
        let finished = null;
        if (fleet.tasks.length > 0) {
            finished = fleet.tasks[0].steps[fleet.tasks[0].current_step].finished;
        }

        if (!finished) {
            return <tr>
                <td>Time:</td>
                <td>
                    <pre style={{ padding: 0, margin: 0 }}>-</pre>
                </td>
            </tr>
        }
        return <tr>
            <td>Time</td>
            <td>
                <util.Timer date={finished} />
            </td>
        </tr>;
    }
}

class TransferButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = { showFleetChooser: false }
    }

    render() {
        const fleet = this.props.fleet;

        return <div className="modal-host">
            <div className="action-button"
                onClick={() => this.setState({ showFleetChooser: !this.state.showFleetChooser })}>Transfer
            </div>
            {
                !this.state.showFleetChooser ||
                <div className="modal">
                    <div><Link className="link-button" to={"/game/fleet-transfer/" + fleet.id + "/0"}>Orbit</Link></div>
                    {
                        fleet.orbiting_fleets.filter(f => f.owner_id === fleet.owner_id && f.id !== fleet.id).map((f, idx) =>
                            <div key={idx}>
                                <Link className="link-button" to={"/game/fleet-transfer/" + fleet.id + "/" + f.id}>{f.name}</Link>
                            </div>
                        )
                    }
                </div>
            }
        </div>
    }
}

class DisbandButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = { show_input: false, value: "", wrong_input: false };
    }

    render() {
        return <div className="modal-host">
            {this.state.show_input || <div className="action-button" onClick={() => this.setState({ show_input: true })}>Disband</div>}
            {!this.state.show_input || <input style={{ borderColor: this.state.wrong_input ? "red" : undefined }} value={this.props.value} placeholder="type disband" onChange={event => this.setState({ value: event.target.value })} />}
            {!this.state.show_input || <div className="action-button" onClick={() => this.setState({ show_input: false, wrong_input: false, value: "" })}>Cancel</div>}
            {!this.state.show_input || <div className="action-button" onClick={() => this._handleDisbandFleet()}>Ok</div>}
        </div>
    }

    _handleDisbandFleet() {
        if (this.state.value.toLowerCase() === "disband") {
            this.props.onDisbandFleet();
        } else {
            this.setState({ wrong_input: true });
        }
    }
}

export default util.withParamsAndNavigation(FleetView);